module.exports = __webpack_public_path__ + "img/370-thread-count.7b418ff.svg";